import routes from './../routes'
import vue from 'vue'
import {filterResponse, filterErrors} from './../client'

export const getNetworks = () => {
    return vue.http.get(routes.airtime.networks).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getMobileNetwork = (mobile) => {
    return vue.http.get(routes.airtime.getMobileNetwork + mobile).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getSaved = () => {
    return vue.http.get(routes.airtime.saved).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getRecurring = () => {
    return vue.http.get(routes.airtime.recurring).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const updateRecurring = (id,data) => {
    data.authorizationCode = Date.now() + '_' + data.client.id;
    data.channel= 'web';

    return vue.http.put(routes.airtime.updateRecurring + id, data).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const deleteSaved = (id) => {
    return vue.http.delete(routes.airtime.deleteSaved + id).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const postTopup = (data) => {
    data.authorizationCode = Date.now() + '_' + data.client.id;
    data.channel= 'web';

    return vue.http.post(routes.airtime.topup, data).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getTransactionStatus = (transactionId) => {
    return vue.http.get(routes.airtime.transactionStatus + transactionId).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getHistory = (clientId) => {
    return vue.http.get(routes.airtime.history + `clientId=${clientId}`).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const deleteRecurringAirtime = ( id ) => {
    return vue.http.delete(routes.airtime.deleteRecurring + id).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}